module.exports = __webpack_public_path__ + "img/img_3_m.6a23f90c.webp";